/** Global styles. Focus outlines are removed globally because every component draws `shadows.outline` on :focus-visible. */
export const styles = {
  global: {
    "html, body": {
      bg: "surface.canvas",
      color: "text.primary",
      fontWeight: 500,
      lineHeight: 1.55,
      fontSize: "0.9375rem",
    },
    "*::selection": { bg: "leaf.200", color: "navy.900" },
    "*:focus-visible": { outline: "none" },
    "::placeholder": { color: "text.muted", fontWeight: 500 },
    "*::-webkit-scrollbar": { w: "10px", h: "10px" },
    "*::-webkit-scrollbar-track": { bg: "transparent" },
    "*::-webkit-scrollbar-thumb": { bg: "sand.300", borderRadius: "full", border: "2px solid var(--chakra-colors-surface-canvas)" },
    "*::-webkit-scrollbar-thumb:hover": { bg: "sand.400" },
    "*": { scrollbarWidth: "thin", scrollbarColor: "var(--chakra-colors-sand-300) transparent" },
    table: { fontVariantNumeric: "tabular-nums lining-nums" },
    "@supports not (backdrop-filter: blur(1px))": {
      ".mbf-glass": { bg: "rgba(255,255,255,0.97) !important" },
    },
  },
};
